import { ApolloClient } from '@apollo/client';

import { IPaymentProviderTokenizeCardParams, IPaymentProviderTokenizeCardReturns, IPaymentProvider } from '../../types';
import {
  GetFiservClientAccessTokenDocument,
  GetFiservClientAccessTokenQuery,
} from '../../../../../graphql/types.generated';
import { Fiserv } from './Fiserv';
import { getPaymentInstrumentTypeByCardType } from '../../../utils';
import { PaymentGatewayTokenizationParameters } from '../../../GooglePay/types';

export class PaymentProviderFiserv implements IPaymentProvider {
  private apolloClient: ApolloClient<any>;

  private googlePayGatewayParameters: PaymentGatewayTokenizationParameters | null = null;

  constructor(
    apolloClient: ApolloClient<any>,
    googlePayGatewayParameters: { gateway: string; gatewayMerchantId: string } | null,
  ) {
    this.apolloClient = apolloClient;
    this.googlePayGatewayParameters = googlePayGatewayParameters;
  }

  tokenizeCard = async (params: IPaymentProviderTokenizeCardParams): Promise<IPaymentProviderTokenizeCardReturns> => {
    const {
      data: {
        getFiservClientAccessToken: { algorithm, publicKey, baseUrl, apiKey, oAuthToken, fdCustomerId },
      },
    } = await this.apolloClient.query<GetFiservClientAccessTokenQuery>({
      query: GetFiservClientAccessTokenDocument,
      fetchPolicy: 'network-only',
    });

    const { nonce } = await Fiserv.tokenize({
      // region | API options
      algorithm,
      publicKey,
      baseUrl,
      apiKey,
      oAuthToken,
      fdCustomerId,
      // endregion
      // region | Card info
      cardType: params.type,
      cardNumber: params.card,
      expirationDateMonth: params.expMonth,
      // Fiserv tokenization works fine with YY format only
      expirationDateYear: params.expYear.slice(-2),
      cvv: params.cvv,
      cardholderName: params.cardholder,
      zipCode: params.postalCode,
      // endregion
    });
    return {
      externalRequestData: null,
      nonce,
      oAuthToken,
      paymentType: getPaymentInstrumentTypeByCardType(params.type),
    };
  };

  tokenizeApplePay = async () => null;

  getGooglePayGatewayParameters = () => {
    if (!this.googlePayGatewayParameters) {
      throw new Error('Payment provider GooglePay Gateway is not specified');
    }
    return this.googlePayGatewayParameters;
  };

  // Fiserv does not use "nonce" for transaction start
  getGooglePayTokenNonce = () => null;
}
